import { FunctionComponent, useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import styles from "./LoginScreen.module.css";

const LoginScreen: FunctionComponent = () => {
    const { login, error, isLoading } = useAuth();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        await login(email, password);
    };

    return (
        <div className={styles.loginScreen}>
            <div className={styles.masterScreen}>
                <div className={styles.header} >
                    <img className={styles.govIcon} alt="" src="/govofshj-3@2x.png" />
                </div>
                <div className={styles.logoContainer}>
                    <img className={styles.manaberlogo} alt="" src="/manaberlogo--copy-3@2x.png" />
                </div>
                <div className={styles.loginContainer}>
                    <div className={styles.loginContainerChild} />
                    <form onSubmit={handleSubmit} className={styles.loginForm}>
                        <b className={styles.loginToManaber}>Login</b>

                        <div className={styles.textfieldEmail}>
                            <div className={styles.textfieldEmailChild} />
                            <div className={styles.textfieldEmailItem} />
                            <div className={styles.email}>Email</div>
                            <input
                                className={styles.inputEmail}
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                placeholder=""
                            />
                        </div>

                        <div className={styles.textfieldPassword}>
                            <div className={styles.textfieldPasswordChild} />
                            <div className={styles.textfieldPasswordItem} />
                            <div className={styles.password}>Password</div>
                            <input
                                className={styles.inputPassword}
                                type={showPassword ? "text" : "password"}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                            <img
                                className={styles.passwordToggleIcon}
                                alt="Toggle password visibility"
                                src={showPassword ? "/image-49@2x.png" : "/image-48@2x.png"}
                                onClick={() => setShowPassword(!showPassword)}
                            />
                        </div>

                        {error && <div className={styles.errorMessage}>{error}</div>}

                        <button
                            type="submit"
                            className={styles.loginButton}
                            disabled={isLoading}
                        >
                            {isLoading ? (
                                <div className={styles.loadingSpinner}></div>
                            ) : (
                                <>
                                    <div className={styles.loginText}>Login</div>
                                </>
                            )}
                        </button>
                    </form>
                </div>
                <div className={styles.masterScreenItem} />
                <div className={styles.byManaberaiAllRightsContainer}>
                    ©&nbsp;2025&nbsp;by&nbsp;
                    <a
                        className={styles.manaberai}
                        href="https://manaber.ai"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <span className={styles.manaberai1}>manaber.ai</span>
                    </a>
                    . All rights reserved.
                </div>
            </div>


        </div >
    );
};

export default LoginScreen;
